import { DatiAnnotazioneList, SectionVM } from 'civil-status/view-models/step-form';

export const transformerDatiAnnotazioneList = (
  idEvento?: number,
  dataAnnotations?: SectionVM,
  dataAnnotationPropertyRegime?: SectionVM
): Array<DatiAnnotazioneList> | undefined => {
  const dataAnnotationsFiltred = (dataAnnotations?.annotations || []).filter(
    (item) => !item.disabled
  );
  if (
    (dataAnnotationsFiltred || []).length === 0 &&
    !Boolean(dataAnnotationPropertyRegime?.annotationsPropertyRegime?.typeContextualAnnotation)
  ) {
    return undefined;
  }

  return (dataAnnotationsFiltred || [])
    .concat(
      dataAnnotationPropertyRegime?.annotationsPropertyRegime
        ? [dataAnnotationPropertyRegime?.annotationsPropertyRegime]
        : []
    )
    ?.map((itemAnnotation) => ({
      key: {
        idDatiAnnotazione: itemAnnotation.idAnnotazione || undefined,
      },
      idEvento,
      annotazione: itemAnnotation.textContextualAnnotation || undefined,
      tipoAnnotazione: itemAnnotation.typeContextualAnnotation || undefined,
      flagAnnotazioneNonCert: itemAnnotation.isNotCertifiable ? '1' : '0',
    }));
};
